const STORAGE_KEY = 'bordatec-wishlist-v1';

function readHandles() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeHandles(handles) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handles } }));
}

export const Wishlist = {
  getAll: readHandles,
  has(handle) {
    return readHandles().includes(handle);
  },
  toggle(handle) {
    const handles = readHandles();
    const index = handles.indexOf(handle);
    if (index === -1) handles.push(handle);
    else handles.splice(index, 1);
    writeHandles(handles);
    return handles.includes(handle);
  },
};

function syncButton(button) {
  const active = Wishlist.has(button.dataset.productHandle);
  button.classList.toggle('wishlist-button--active', active);
  button.setAttribute('aria-pressed', String(active));
}

function syncAllButtons(scope = document) {
  scope.querySelectorAll('.wishlist-button').forEach(syncButton);
}

function syncCounts() {
  const count = Wishlist.getAll().length;
  document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
    el.textContent = count > 0 ? String(count) : '';
    el.hidden = count === 0;
  });
}

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('.wishlist-button') : null;
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  Wishlist.toggle(button.dataset.productHandle);
});

document.addEventListener('wishlist:change', () => {
  syncAllButtons();
  syncCounts();
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) syncAllButtons(event.target);
});

syncAllButtons();
syncCounts();
